import { Container, Row, Col } from "react-bootstrap";
import "../style.scss";
import "bootstrap/dist/css/bootstrap.min.css";

function Footer() {
  return (
    <Container>
      <Row>
        <Col md={12} className="center-aligned-div">
          <p>Let's Connect</p>
          <ul className="links">
            <li className="icons">
              <a
                href="https://github.com/mohit4444"
                target="_blank"
                rel="noreferrer"
                className="icons-dtls"
              >
                <i className="fab fa-github"></i>
              </a>
            </li>
            <li className="icons">
              <a
                href="https://in.linkedin.com/in/mohit-bidikar-756348123"
                target="_blank"
                rel="noreferrer"
                className="icons-dtls"
              >
                <i className="fab fa-linkedin"></i>
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
